import React, { useState } from 'react';
import { useSecurity } from '../../../helpers/SecurityHooks';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { appendScriptsCallback, formatDate, formatDateTime } from '../../../helpers/Utils';
import { useParams } from 'react-router-dom';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { getEntityDetails, getPreferredDetails  } from '../../../../services/ApiServices';

export function TradingRevenueStreamNewPage(): React.ReactElement {
  const [state, setState] = useState<ITradingRevenueStream>({ Id: "" , LoadingInfo: {} , Sequence: "0"  });
  const currentSecurity = useSecurity('Trading', 'RevenueStream');
  const updatedState: ITradingRevenueStream = { Id: "" , LoadingInfo: {} , Sequence: "0"  };
  React.useEffect(() => {
    if (currentSecurity.checkAccess()) {
            updatedState.Type = 0;
            updatedState.RevenueGroup = 0;
            updatedState.BillingSource = 0;
            updatedState.RevenueSource = 0;
            updatedState.MappingType = 0;
      setState(updatedState);
      appendScriptsCallback(["Areas/Trading/Scripts/Resources/en/res.RevenueStream.en.js",
        "Areas/Trading/Scripts/Resources/en/Types.en.js",
        "Areas/Trading/Scripts/Enums.js",
        "Areas/Trading/Scripts/RevenueStream/View.js"], "initNewTradingRevenueStream", { viewmodel : updatedState, canEdit: true, canCreate: true, canRemove: true, });
    }
  }, []);
  return (
    <div className="container-fluid">
      <section id="patron">
        <section className="content">
          <div className="clear"></div>
          <section id="viewContent">
          <div id="RevenueStream" className="controls-container default block">
              <h3>Create a New <b>Revenue Streams</b></h3>
              <p>Please fill in the fields, once completed click on Save to proceed with the creation:</p>
              <form id="form" action="" className="content-view row">
		<div className="col-md-2" ><label>Code</label><input id="RevenueStreamCode" max="20" name="Code" type="text" defaultValue={state.Code} className="shortcontrol disabled k-input k-input-solid k-textbox" readOnly disabled  placeholder="AUTO-CODE" /></div>
			<div className="col-md-2">
				<label id="RevenueStreamLabelBlockedCode">Blocked</label>
				<input id="RevenueStreamCheckBlockedCode" defaultChecked name="RevenueStreamCheckBlockedCode" type="checkbox" />
			</div>
			<div className="clear"></div>
		<div className="col-md-4 combobox  " ><label htmlFor="AgencyId">Agency</label><select className="" id="RevenueStreamAgencyId" name="AgencyId" defaultValue={state.AgencyId}   required data-required-msg="Agency is required"  >{state.AgencyId && <option value={state.AgencyId}>{state.AgencyDisplayValue}</option>}</select></div>
		<div className="col-md-4 combobox  " ><label htmlFor="CommissionOnId">Commission On</label><select className="" id="RevenueStreamCommissionOnId" name="CommissionOnId" defaultValue={state.CommissionOnId}  >{state.CommissionOnId && <option value={state.CommissionOnId}>{state.CommissionOnDisplayValue}</option>}</select></div>
		<div className="col-md-4 combobox  " ><label htmlFor="ManualStreamId">Source Stream</label><select className="" id="RevenueStreamManualStreamId" name="ManualStreamId" defaultValue={state.ManualStreamId}  >{state.ManualStreamId && <option value={state.ManualStreamId}>{state.ManualStreamDisplayValue}</option>}</select></div>
		<div className="col-md-4" ><label htmlFor="BillingReference">Billing Reference</label><input  id="RevenueStreamBillingReference" name="BillingReference" type="text" defaultValue={state.BillingReference} className="k-input k-input-solid k-textbox" /></div>
		<div className="col-md-4" ><label htmlFor="Alias">Alias</label><input  required data-required-msg="Alias is required"  id="RevenueStreamAlias" name="Alias" type="text" defaultValue={state.Alias} className="k-input k-input-solid k-textbox" /></div>
        <div className="clear"></div>
		<div className="field textareafield"><label htmlFor="Comments">Comments</label><div><textarea className="k-input k-textbox" cols={20} id="RevenueStreamComments" name="Comments" maxLength={2147483647} rows={5} defaultValue={state.Comments}></textarea></div></div>
		<div className="col-md-2 dropdownlist  " >
      <label htmlFor="BillingSource" className="required">Billing Source</label>
      <select className="" id="RevenueStreamBillingSource" name="BillingSource" value={state.BillingSource} required data-required-msg="Billing Source is required" >
        <option value="0">Scribes</option>
        <option value="1">DDS Spend</option>
        <option value="2">Manual</option>
        <option value="3">Calculated</option>
        <option value="4">Scribes + Manual</option>
      </select>
    </div>
		<div className="col-md-2 dropdownlist  " >
      <label htmlFor="MappingType" className="required">Mapping Type</label>
      <select className="" id="RevenueStreamMappingType" name="MappingType" value={state.MappingType} required data-required-msg="Mapping Type is required" >
        <option value="0">Default</option>
        <option value="1">Custom</option>
      </select>
    </div>
		<div className="col-md-2 dropdownlist  " >
      <label htmlFor="RevenueGroup" className="required">Revenue Group</label>
      <select className="" id="RevenueStreamRevenueGroup" name="RevenueGroup" value={state.RevenueGroup} required data-required-msg="Revenue Group is required" >
        <option value="0">Agency</option>
        <option value="1">Nexus</option>
        <option value="2">Value Amplification</option>
        <option value="3">TBD</option>
      </select>
    </div>
		<div className="col-md-2 dropdownlist  " >
      <label htmlFor="RevenueSource" className="required">Revenue Source</label>
      <select className="" id="RevenueStreamRevenueSource" name="RevenueSource" value={state.RevenueSource} required data-required-msg="Revenue Source is required" >
        <option value="0">Scribes</option>
        <option value="1">DDS Spend</option>
        <option value="2">Manual</option>
        <option value="3">Calculated</option>
        <option value="4">Scribes + Manual</option>
      </select>
    </div>
		<div className="col-md-2 dropdownlist  " >
      <label htmlFor="Type" className="required">Revenue Type</label>
      <select className="" id="RevenueStreamType" name="Type" value={state.Type} required data-required-msg="Revenue Type is required" >
        <option value="0">Billing</option>
        <option value="1">Revenue</option>
      </select>
    </div>
		<div className="col-md-2" ><label htmlFor="Sequence" className="required">Sequence</label><input data-required-msg="Sequence is required" data-val="true" data-val-number="The field Sequence must be a number." defaultValue={state.Sequence} data-val-required="The Sequence field is required." id="RevenueStreamSequence" min="-2147483648" name="Sequence" required type="text" /></div>
		<div className="col-md-4" ><label htmlFor="SourceReference">Source Reference</label><input id="RevenueStreamSourceReference" max="60" name="SourceReference" type="text" defaultValue={state.SourceReference} className="shortcontrol k-input k-input-solid k-textbox"  placeholder="SOURCE-REFERENCE" /></div>
              </form>
              <section className="button-toolbar" id="ToolbarRevenueStream">
                <div className="left">
                  <button id="cancelRevenueStreamButton" type="button" className="k-button button" title="Cancel">Cancel</button>
                </div>
		            <div className="right">
                  <button id="saveRevenueStreamButton" type="button" className="k-button button" title="Save">Save</button>
                </div>
              </section>
            </div>
          </section>
        </section>
      </section>
    </div>
  );
}

interface ITradingRevenueStream {
  LoadingInfo: {
    CreationDate?: string,
    CreatedBy?: string,
    CreatedByDisplayValue?: string,
    UpdateDate?: string,
    UpdatedBy?: string,
    UpdatedByDisplayValue?: string,
    SourceStatus?: number,
    Source?: number
  },
  Sequence?: string,
  AgencyId?: string,
  AgencyDisplayValue?: string,
  CommissionOnId?: string,
  CommissionOnDisplayValue?: string,
  ManualStreamId?: string,
  ManualStreamDisplayValue?: string,
  BillingReference?: string,
  Alias?: string,
  Comments?: string,
  BillingSource?: number,
  MappingType?: number,
  RevenueGroup?: number,
  RevenueSource?: number,
  Type?: number,
  Code?: string,
  Display?: string,
  EntityStatus?: number,
  SourceReference?: string,
  Id: string,
  InactiveFrom?: Date
}

	
// eslint-disable-next-line @typescript-eslint/no-unused-vars
enum RevenueGroupCategoryEnum { 'Agency' = 0, 'Nexus' = 1, 'Value Amplification' = 2, 'TBD' = 3 }
	
// eslint-disable-next-line @typescript-eslint/no-unused-vars
enum RevenueTypeEnum { 'Billing' = 0, 'Revenue' = 1 }
	
// eslint-disable-next-line @typescript-eslint/no-unused-vars
enum RevenueSourceEnum { 'Scribes' = 0, 'DDS Spend' = 1, 'Manual' = 2, 'Calculated' = 3, 'Scribes + Manual' = 4 }
	
// eslint-disable-next-line @typescript-eslint/no-unused-vars
enum DataMappingTypeEnum { 'Default' = 0, 'Custom' = 1 }

export function TradingRevenueStreamDetailPage(): React.ReactElement {
  const { id } = useParams();
  const [state, setState] = useState<ITradingRevenueStream>({ Id: "" , LoadingInfo: {} , Sequence: "0"  });
  const currentSecurity = useSecurity('Trading', 'RevenueStream');
  React.useEffect(() => {
    if (state.Id == "" && currentSecurity.checkAccess()) {
      getEntityDetails("Trading", "RevenueStream", id).then(result => {
        setState(result.Value[0] as ITradingRevenueStream);
        appendScriptsCallback(["Areas/Trading/Scripts/Resources/en/res.RevenueStream.en.js",
        "Areas/Trading/Scripts/Resources/en/Types.en.js",
        "Areas/Trading/Scripts/Enums.js",
        "Areas/Trading/Scripts/RevenueStream/View.js"
        ,"Areas/Trading/Scripts/Resources/en/res.RevenueStreamMap.en.js"
        ,"Areas/Trading/Scripts/RevenueStreamMap/View.js"
        ,"Areas/Trading/Scripts/Resources/en/res.RevenueStreamMapBilling.en.js"
        ,"Areas/Trading/Scripts/RevenueStreamMapBilling/View.js"
        ,"Areas/Trading/Scripts/Resources/en/res.MediaToolsRevenueStream.en.js"
        ,"Areas/Trading/Scripts/MediaToolsRevenueStream/View.js"
        ], "initDetailTradingRevenueStream", { viewmodel: result.Value[0], canEdit: true, canCreate: true, canRemove: true, id: id});
      });
    }
  }, []);
  window['reloadTradingRevenueStreamState'] = (data) => {
    setState(data.Value[0] as ITradingRevenueStream);
  };
  return (
    <div className="container-fluid">
      <section id="patron" style={{ display: 'none' }}>
        <section className="content">
          <div className="clear"></div>
          <section id="viewContent">
            <div id="RevenueStream" className="controls-container default block">
              <div className="content-label">
                <div className="content-title">
                    <div className="k-content">
                        <h3>Revenue Streams: <span>{state.Display}</span><span id="RevenueStreamToggle" className="k-icon k-i-media-manager" style={{ cursor: 'pointer' }} ></span></h3>
                    </div>
                </div>
                <div className='content-line'>
                  {state.AgencyId && <span className='element'><label>Agency: <label className="strong">{state.AgencyDisplayValue}</label></label></span>}
                  {state.CommissionOnId && <span className='element'><label>Commission On: <label className="strong">{state.CommissionOnDisplayValue}</label></label></span>}
                  {state.ManualStreamId && <span className='element'><label>Source Stream: <label className="strong">{state.ManualStreamDisplayValue}</label></label></span>}
                </div>
              </div>
              <form id="form" action="" style={{ display: 'none'}} className="content-view row">
		<div className="col-md-2" ><label>Code</label><input id="RevenueStreamCode" max="20" name="Code" type="text" defaultValue={state.Code} className="shortcontrol disabled k-input k-input-solid k-textbox" readOnly disabled  placeholder="AUTO-CODE" /></div>
			<div className="col-md-2">
				<label id="RevenueStreamLabelBlockedCode">Blocked</label>
				<input id="RevenueStreamCheckBlockedCode" defaultChecked name="RevenueStreamCheckBlockedCode" type="checkbox" />
			</div>
			<div className="clear"></div>
		<div className="col-md-4 combobox  " ><label htmlFor="AgencyId">Agency</label><select className="" id="RevenueStreamAgencyId" name="AgencyId" defaultValue={state.AgencyId}   required data-required-msg="Agency is required"  >{state.AgencyId && <option value={state.AgencyId}>{state.AgencyDisplayValue}</option>}</select></div>
		<div className="col-md-4 combobox  " ><label htmlFor="CommissionOnId">Commission On</label><select className="" id="RevenueStreamCommissionOnId" name="CommissionOnId" defaultValue={state.CommissionOnId}  >{state.CommissionOnId && <option value={state.CommissionOnId}>{state.CommissionOnDisplayValue}</option>}</select></div>
		<div className="col-md-4 combobox  " ><label htmlFor="ManualStreamId">Source Stream</label><select className="" id="RevenueStreamManualStreamId" name="ManualStreamId" defaultValue={state.ManualStreamId}  >{state.ManualStreamId && <option value={state.ManualStreamId}>{state.ManualStreamDisplayValue}</option>}</select></div>
		<div className="col-md-4" ><label htmlFor="BillingReference">Billing Reference</label><input  id="RevenueStreamBillingReference" name="BillingReference" type="text" defaultValue={state.BillingReference} className="k-input k-input-solid k-textbox" /></div>
		<div className="col-md-4" ><label htmlFor="Alias">Alias</label><input  required data-required-msg="Alias is required"  id="RevenueStreamAlias" name="Alias" type="text" defaultValue={state.Alias} className="k-input k-input-solid k-textbox" /></div>
        <div className="clear"></div>
		<div className="field textareafield"><label htmlFor="Comments">Comments</label><div><textarea className="k-input k-textbox" cols={20} id="RevenueStreamComments" name="Comments" maxLength={2147483647} rows={5} defaultValue={state.Comments}></textarea></div></div>
		<div className="col-md-2 dropdownlist  " >
      <label htmlFor="BillingSource" className="required">Billing Source</label>
      <select className="" id="RevenueStreamBillingSource" name="BillingSource" value={state.BillingSource} required data-required-msg="Billing Source is required" >
        <option value="0">Scribes</option>
        <option value="1">DDS Spend</option>
        <option value="2">Manual</option>
        <option value="3">Calculated</option>
        <option value="4">Scribes + Manual</option>
      </select>
    </div>
		<div className="col-md-2 dropdownlist  " >
      <label htmlFor="MappingType" className="required">Mapping Type</label>
      <select className="" id="RevenueStreamMappingType" name="MappingType" value={state.MappingType} required data-required-msg="Mapping Type is required" >
        <option value="0">Default</option>
        <option value="1">Custom</option>
      </select>
    </div>
		<div className="col-md-2 dropdownlist  " >
      <label htmlFor="RevenueGroup" className="required">Revenue Group</label>
      <select className="" id="RevenueStreamRevenueGroup" name="RevenueGroup" value={state.RevenueGroup} required data-required-msg="Revenue Group is required" >
        <option value="0">Agency</option>
        <option value="1">Nexus</option>
        <option value="2">Value Amplification</option>
        <option value="3">TBD</option>
      </select>
    </div>
		<div className="col-md-2 dropdownlist  " >
      <label htmlFor="RevenueSource" className="required">Revenue Source</label>
      <select className="" id="RevenueStreamRevenueSource" name="RevenueSource" value={state.RevenueSource} required data-required-msg="Revenue Source is required" >
        <option value="0">Scribes</option>
        <option value="1">DDS Spend</option>
        <option value="2">Manual</option>
        <option value="3">Calculated</option>
        <option value="4">Scribes + Manual</option>
      </select>
    </div>
		<div className="col-md-2 dropdownlist  " >
      <label htmlFor="Type" className="required">Revenue Type</label>
      <select className="" id="RevenueStreamType" name="Type" value={state.Type} required data-required-msg="Revenue Type is required" >
        <option value="0">Billing</option>
        <option value="1">Revenue</option>
      </select>
    </div>
		<div className="col-md-2" ><label htmlFor="Sequence" className="required">Sequence</label><input data-required-msg="Sequence is required" data-val="true" data-val-number="The field Sequence must be a number." defaultValue={state.Sequence} data-val-required="The Sequence field is required." id="RevenueStreamSequence" min="-2147483648" name="Sequence" required type="text" /></div>
		<div className="col-md-4" ><label htmlFor="SourceReference">Source Reference</label><input id="RevenueStreamSourceReference" max="60" name="SourceReference" type="text" defaultValue={state.SourceReference} className="shortcontrol k-input k-input-solid k-textbox"  placeholder="SOURCE-REFERENCE" /></div>
                <div className="clear"></div>
                <div className="content-header">Tracking</div>
                <div className="col-md-4" ><label htmlFor="LoadingInfo_SourceStatus">Loading Status</label><select className="" id="RevenueStreamSourceStatus" name="LoadingInfo.SourceStatus" value={state.LoadingInfo.SourceStatus} ><option value="0">Loaded</option><option value="1">Processed</option><option value="2">Pending</option><option value="3">Reloaded</option><option value="4">Error</option></select></div><div className="col-md-4" ><label htmlFor="LoadingInfo_Source">Source</label><select className="" id="RevenueStreamSource" name="LoadingInfo.Source" value={state.LoadingInfo.Source} ><option value="0">Owned</option><option value="1">ExternalPlanning</option><option value="2">ExternalBuying</option><option value="3">ExternalFinance</option><option value="4">ExternalHub</option></select></div><div className="clear"></div>
                <div className="trackinfo">
                    <div className="line">Created on <span className="when">{formatDateTime(state.LoadingInfo.CreationDate)}</span> by <span className="who">{state.LoadingInfo.CreatedByDisplayValue}</span> </div>
                    <div className="line">Last Update on <span className="when">{formatDateTime(state.LoadingInfo.UpdateDate)}</span> by <span className="who">{state.LoadingInfo.UpdatedByDisplayValue}</span> </div>
                </div>
              </form>
              <section className="button-toolbar" style={{ display: 'none'}} id="ToolbarRevenueStream">
                <div className="left">
                  <button id="cancelRevenueStreamButton" type="button" className="k-button button" title="Cancel">Cancel</button>
                </div>
		            <div className="right">
                  <button id="saveRevenueStreamButton" type="button" className="k-button button" title="Save">Save</button>
                </div>
              </section>
            </div>
          </section>
            <div id="RevenueStreamTabstrip">
                <ul>
                    <li id="RevenueStreamRevenueStreamMap" className="k-active"><i className="fas fa-braille"></i><span className="labeltext">Standard Mappings</span></li>
                    <li id="RevenueStreamRevenueStreamMapBilling"><i className="fas fa-braille"></i><span className="labeltext">Billing Mappings</span></li>
                    <li id="RevenueStreamMediaToolsRevenueStream"><i className="fas fa-chart-line"></i><span className="labeltext">MediaTools Media Category</span></li>
                </ul>
                <div>
                    <div id="associationRevenueStreamRevenueStreamMap">
                      <div className="k-block grid-details">
                        <h2>Standard Mappings</h2>
                        <div id="RevenueStreamMapGrid" className="grid-control"></div>
                      </div>
                    </div>
                </div>
                <div>
                    <div id="associationRevenueStreamRevenueStreamMapBilling">
                      <div className="k-block grid-details">
                        <h2>Billing Mappings</h2>
                        <div id="RevenueStreamMapBillingGrid" className="grid-control"></div>
                      </div>
                    </div>
                </div>
                <div>
                    <div id="associationRevenueStreamMediaToolsRevenueStream">
                      <div className="k-block grid-details">
                        <h2>MediaTools Media Category</h2>
                        <div id="MediaToolsRevenueStreamGrid" className="grid-control"></div>
                      </div>
                    </div>
                </div>
            </div>
        </section>
      </section>
    </div>
  );
}


